export default __webpack_public_path__ + "static/media/logo-small.a8f559fe.svg";